<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid" id="blurry">
    <div class="row signup-page">
      <div class="circle_background_mob" ></div>
      <div class="col-lg-12 touch_bottom">
        <div class="signup-page--right whiteandround">
          <div class="login-form">
            <div class="logo_form">
            </div>
            <div class="form_title">
            <h1>{{ getTranslations.visitor_sign_up_2_2steps_left }}</h1>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasStepsToDisplay">
              <div class="StandardRegSteps_step step_done">1</div>
              <div class="StandardRegSteps_step">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
            <div class="twoStepRegSteps_Container" v-else>
              <div class="twoStepRegSteps_step step_done">1</div>
              <div class="twoStepRegSteps_step">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help extra_padng_2">
              <img class="operators_icon" :src="getOperatorImage(operatorIndex)" :alt="getOperatorDisplayName(operatorIndex)" v-if="checkForOperatorImage()">
              <img class="form-help__icon"
                   :src="['static/images/mobile-icon.svg']"
                   alt="" v-else>
              <p v-if="checkForOperatorImage()">{{ getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_disclaimer') }}</p>
              <p v-else>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
            </div>
            <form action="" id="signUp2">
              <div class="form-group form-group--icon"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="password"
                       class="password form-group__textfield"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check"
                       v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin"
                      class="form-group__feedback">{{ getMessage(message) }}
                </span>
              </div>
              <input type="submit" id="submitButton"
                     :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main' , ( hasErrors || waitForResponse || !termsParameter ? 'deactivated' : '')]"
                     @click.prevent="checkButton">
              <div v-if="checkBoxEnabled">
<!--                <div class="form-group for_selected_op form-group&#45;&#45;checkbox center">-->
<!--                  <input id="remember_me" type="checkbox" value="remember_me_checked" v-model="rememberMeParameter">-->
<!--                  <label for="remember_me">-->
<!--                    {{ getTranslations.visitor_sign_up_2_remember_me }} Remember me-->
<!--                  </label>-->
<!--                </div>-->
                <div class="form-group for_selected_op form-group--checkbox center">
                  <input id="check" type="checkbox" value="terms_checked" v-model="termsParameter">
                  <label v-if="!getTranslations.visitor_sign_up_3_terms_and_conditions && getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_check_box_terms')" for="check">{{ getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_check_box_terms') }}</label>
                  <label v-else-if="!getTranslations.visitor_sign_up_3_terms_and_conditions && !getTranslationByOperator(operatorIndex, 'visitor_sign_up_2_check_box_terms')" for="check">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_first_text') }} <br><a>
                    <a :href="getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_first_link_url')" target="_blank">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_first_link_text') }}</a>
                  </a>{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_second_text') }} <br><a>
                    <a :href="getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_second_link_url')" target="_blank">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_second_link_text') }}</a>
                  </a>{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_third_text') }} <br><a>
                    <a :href="getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_third_link_url')" target="_blank">{{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_third_link_text') }}</a>
                  </a>
                    <br>
                    {{ getTranslationByOperatorIfExists(operatorIndex, 'visitor_sign_up_2_check_fourth_text') }}
                  </label>
                  <label v-else for="check">{{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                    <a :href="getTranslationByOperator(operatorIndex, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
                  </a></label>
                </div>
              </div>
              <div class="form-footer" v-if="!checkBoxEnabled">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
              </a>
              </div>
              <p v-if="displayPrice">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_price') }}</p>
              <br/>
              <br/>
              <a href="https://www.google.com" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit') }}
              </a>
              <br/>
              <br/>
              <div v-if="hasSimplify()"
                  class="form-footer-text">
                <span  v-for="(key, index) in disclaimers"
                    v-if="getTranslations[key]"
                    :key="index">
                  {{ getTranslations[key] }}
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <loading v-if="showLoadingModal"
             @close="showLoadingModal = false">
    </loading>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import IntegrationMixin from '@/common/mixins/integration';
import loading from '@/components/home/modals/Loading';

export default {
  name: 'sign-up-2',
  components: { loading },
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      ti: null,
      ts: null,
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
      hasStepsToDisplay: false,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3', 'visitor_sign_up_disclaimer_text4'],
      rememberMeParameter: true,
      termsParameter: false,
      // Purpose: Controls when the submit button is enabled (only after DVPass script loads)
      dvPassReady: false,
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSteps();
    const inputMsisdn = sessionStorage.getItem('msisdn') || this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    const operator = this.$route.query.operator || sessionStorage.getItem('operator');
    if (!this.checkBoxEnabled) this.termsParameter = true;
    if (operator) {
      this.storeOperator(operator);
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((response) => {
        this.updateMultiOperatorOrdinal({ value: response.data.data.multiOperatorOrdinal });
        this.setDisplayPrice({ value: response.data.data.displayPrice });
      });
    }

    // Purpose: Loads DVPass script and sets up fraud detection
    if (this.integrationHeader === this.availableIntegrations.VODAFONE_OMAN.name) {
      this.initializeDVPassScript();
    }
  },
  mounted() {
    /* eslint-disable */
    if (sessionStorage.getItem('operator') === 'ZAIN_KSA' && this.integrationHeader === this.availableIntegrations.KSA_MOBILY.name) {
      const ids = {
        form: 'signUp2',
        confirm_button: 'submitButton',
        cancel_button: 'notUsed' // not used please remove it before the commit
      };
      const partner = 'partner:4d823a08bf827d3503647cf167ff48506eeeaa72';
      const service = 'campaign:6c1874a26d0a39b7f3a0cdedc482e4b7690f3b3f';

      const detector = new Detector(ids, partner, service);
      detector.setup();
      const form = document.getElementById(ids['form']);
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        function fraudDetectorLoaded() {
          const loaded = document.getElementById('fraudDetectorIsLoaded');
          if (loaded && loaded.value === 'yes') {
            form.submit();
          } else if ('requestIdleCallback' in window) {
            requestIdleCallback(fraudDetectorLoaded);
          } else {
            setTimeout(fraudDetectorLoaded, 100);
          }
        }
        fraudDetectorLoaded();
      });
    }
    /* eslint-enable */
  },
  methods: {
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
      'setDVPassJWT',
      'setDVPassChallenge',
    ]),

    async initializeDVPassScript() {
      try {
        // eslint-disable-next-line no-console
        console.log('Initializing DVPass anti-fraud script...');

        // Determine subscription type
        const jwt = this.getDVPassJWT;
        // eslint-disable-next-line no-console
        console.log('initializeDVPassScript JWT:', jwt);
        // Load DVPass script with backend-generated JWT
        await this.loadDVPassScript(jwt);
        // this.setDVPassChallenge('6dddff6f-ced6-45b6-9b6b-70d9bb77e8e2');
      } catch (error) {
        // eslint-disable-next-line no-console
        this.setDVPassChallenge('6dddff6f-ced6-45b6-9b6b-70d9bb77e8e2');
        console.error('DVPass initialization failed:', error);
        // Allow user to proceed even if DVPass fails
        this.waitForResponse = false;
      }
    },

// Purpose: Dynamically loads DVPass companion script from CDN
    async loadDVPassScript(jwt) {
      // eslint-disable-next-line no-console
      console.log('DVPass JWT:', jwt);
      const targetElement = encodeURIComponent('#submitButton');
      // eslint-disable-next-line no-console
      console.log('DVPass script URL:', `https://merchants.dvpass.io/companion/${jwt}?te=${targetElement}&include=dcbProtect`);

      return new Promise((resolve, reject) => {
        try {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          // DVPass companion script URL with backend-generated JWT
          script.src = `https://merchants.dvpass.io/companion/${jwt}?te=${targetElement}&include=dcbProtect`;

          // IMPORTANT: Initialize SDK AFTER script loads successfully
          script.onload = () => {
            // eslint-disable-next-line no-console
            console.log('DVPass script loaded successfully with backend JWT');

            // NOW initialize the SDK after the script has loaded
            this.initializeDVPassSDK();
            resolve();
          };

          script.onerror = (error) => {
            // eslint-disable-next-line no-console
            console.error('Failed to load DVPass script:', error);
            // Allow user to proceed even if script fails to load
            this.waitForResponse = false;
            reject(error);
          };

          // Add script to document head
          document.head.appendChild(script);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error creating DVPass script:', error);
          // Allow user to proceed on error
          this.waitForResponse = false;
          reject(error);
        }
      });
    },

// DVPass SDK initialization method
// Purpose: Initializes DVPass SDK and sets up event listeners
    initializeDVPassSDK() {
      // Add a small delay to ensure the script is fully executed
      setTimeout(() => {
        // Check if DVPass global object is available
        console.log('Window:', window);
        console.log('Window.dvpass:', window.dvpass);

        if (typeof window.dvpass !== 'undefined') {
          try {
            // Initialize DVPass SDK as per documentation
            window.dvpass.initialize();
            console.log('DVPass SDK initialized');

            // IMPORTANT: Listen for DVPass loaded event
            // Purpose: This event fires when DVPass is ready to generate challenge tokens
            document.addEventListener('dvpass-loaded', (e) => {
              // eslint-disable-next-line no-console
              console.log('DVPass loaded event received:', e.detail);

              // Check if dcbProtect module is loaded
              if (e.detail && e.detail.script === 'dcbProtect') {
                // Enable the submit button
                this.waitForResponse = false;

                // KEY FUNCTIONALITY: Extract challenge token from DVPass
                // Purpose: This challenge token proves user behavior is legitimate
                if (typeof window.dvpass.getDcbProtectChallenge === 'function') {
                  const challenge = window.dvpass.getDcbProtectChallenge();

                  // 🔴 STORE IN VUEX: Save challenge for later use in API calls
                  if (challenge) {
                    this.setDVPassChallenge(challenge);
                    // eslint-disable-next-line no-console
                    console.log('Retrieved DVPass challenge on demand:', challenge);
                  } else {
                    console.warn('No challenge returned from getDcbProtectChallenge()');
                  }
                } else {
                  console.warn('getDcbProtectChallenge function not available');
                }

                // eslint-disable-next-line no-console
                console.log('DVPass anti-fraud system ready (backend JWT)');
              }
            });

            // Also set up a one-time check after a delay in case the event already fired
            setTimeout(() => {
              // If we still haven't received the event, try to get the challenge directly
              if (this.waitForResponse !== false && typeof window.dvpass.getDcbProtectChallenge === 'function') {
                const challenge = window.dvpass.getDcbProtectChallenge();
                if (challenge) {
                  this.setDVPassChallenge(challenge);
                  this.waitForResponse = false;
                  console.log('Retrieved DVPass challenge via fallback check:', challenge);
                }
              }
            }, 1000);

          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error initializing DVPass SDK:', error);
            // Allow user to proceed if SDK initialization fails
            this.waitForResponse = false;
          }
        } else {
          // eslint-disable-next-line no-console
          console.warn('DVPass SDK not available after script load');
          // Allow user to proceed if SDK is not available
          this.waitForResponse = false;
        }
      }, 100); // Small delay to ensure script execution
    },

    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    checkIfTranslationEmptyByOrdinal(ordinal, key) {
      const indexKey = (ordinal ? `${key}.${ordinal}` : key);
      return !this.getTranslations[indexKey];
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${encodeURIComponent(this.getRegistrationInfo)}&lang=${this.getLocale}`).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.$router.push('register2');
        } else {
          if (res === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (res === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (res === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (res === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (res === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (res === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },

    // Purpose: Ensures DVPass is ready before allowing form submission
    checkButton() {
      const tokenElement = document.querySelector('input[name="token"]');
      if (tokenElement !== null) {
        this.ti = tokenElement.value;
      }

      if (this.user.pin.length >= 4 && this.user.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;

        // Proceed with normal flow - DVPass challenge will be included in API calls
        // via the registration flow mixin
        const alternateVerifyStep = this.getAlternateVerifyPinAction(this.ti);
        if (alternateVerifyStep) {
          alternateVerifyStep.call(this);
        } else {
          this.getNextRegistrationStep()();
        }
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
    getOperatorImage(operatorIndex) {
      return this.getTranslationByOperator(operatorIndex, 'visitor_sign_up_1_operator_image');
    },
    getOperatorDisplayName(operatorIndex) {
      return this.multiOperatorInfo.multiOperatorDisplayNames[operatorIndex];
    },
    showDisclaimerNotice() {
      if (this.multiOperatorInfo.multiOperatorEnabled) {
        return this.multiOperatorInfo.multiOperatorKeys[this.operatorIndex];
      }
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, 'visitor_sign_up_2_disclaimer');
    },
    getOrdinalByOperator(operator) {
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((res) => {
        this.updateMultiOperatorOrdinal({ value: res.data.data.multiOperatorOrdinal });
      });
    },
    checkForOperatorImage() {
      return this.getTranslationByOperator(this.operatorIndex, 'visitor_sign_up_2_disclaimer') && this.multiOperatorInfo.multiOperatorEnabled;
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'displayPrice',
      'operatorIndex',
      'checkBoxEnabled',
      'integrationHeader',
      'availableIntegrations',
      'dvPassChallenge',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getTranslationByOperatorIfExists',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
      'getDailySubscription',
      'getDVPassJWT',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp2.vue